module.exports = __webpack_public_path__ + "static/media/offer-bg.24020476.png";